module.exports = __webpack_public_path__ + "img/cover_photo.9e630b7d.jpg";